import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { NewsService } from '../../service/news.service';
declare var $:any;
@Component({
	selector: 'app-news-virus',
	templateUrl: './news-virus.component.html',
	styleUrls: ['./news-virus.component.styl','../../share/breadcrumb/breadcrumb.component.styl']
})
export class NewsVirusComponent implements OnInit {
	hasNews: boolean;
	showLists: any;
	page: any = {pageIndex: 1, pageCount: 1};  //获取当前页和总页数
	newsTabs: any = ['All', 'College/University Policies', 'Visa Policies', 'Standardized Tests', 'Others'];
	activeIndex: any = 0;
	searchKey: any = '';

	constructor(
		private navigateService: NavigateService,
		private newsService: NewsService
	){
		this.hasNews = true;
	}

	ngOnInit() {
		this.renderList();
		setTimeout(function(){
			$('.wrap-box').css("min-height", $(window).height());
		},0);
	}

	// 列表渲染
	renderList(pageIndex = 1, searchKey?: string){
		const keyWords = searchKey || (this.activeIndex === 0 ? '' : this.newsTabs[this.activeIndex]);
		this.page.pageIndex = pageIndex;
		this.newsService.getNewsVirusList(pageIndex, keyWords).subscribe( res => {
			this.showList(res) , err => {
				if (err && err.status === 401) this.navigateService.pushToRoute('/home');
			}
		})
	}
	showList(list: any){
		this.showLists = list.rows || [];
		this.hasNews = list.rows.length > 0;
		this.page.pageCount = Math.ceil(list.total / 10);
		
		this.showLists.forEach((item: any) => {
			item.links = eval(item.links);
			item.contents = `${item.contents.replace(/<.*?>/ig, '').replace(/&nbsp;/ig, '').slice(0,500)}...`;
		});
	}

	// 跳转至详情
	go(url: string){
		this.navigateService.push();
		this.navigateService.pushToRoute(url);
	}

	// tab点击切换
	tabClick(currentId: number){
		this.activeIndex = currentId;
		this.renderList(); // 选中后渲染列表
	}

	// 搜索
	toSearch(){
		this.activeIndex = 0;
		this.renderList(1, this.searchKey);
	}

	returnList(){
		this.activeIndex = 0;
		this.searchKey = ''; //清空输入框
		this.renderList(1);
	}
}




// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/news/news-virus/news-virus.component.ts